import { Button, Timeline } from 'antd';
import dayjs from 'dayjs';
import styles from './index.module.scss';
import { IPaymentLogs } from './D2RInvoiceSlider';

export const PaymentLogs = ({ paymentLog }: { paymentLog: IPaymentLogs }) => {
	return (
		<Timeline.Item color={paymentLog.remarks.includes('closed') ? 'red' : 'blue'}>
			<div className={styles.paymentLogContainer}>
				<div className={styles.mainContent}>
					<span className={styles.remarks}>{paymentLog.remarks}</span>
					{paymentLog?.proofUrl && (
						<Button
							size="small"
							className={styles.proofButton}
							onClick={() => {
								window.open(`${paymentLog?.proofUrl}`, '_blank');
							}}
						>
							Proof
						</Button>
					)}
				</div>
				{paymentLog?.createdAt && <span className={styles.date}>{dayjs(paymentLog.createdAt).format('MMM DD, YYYY hh:mm A')}</span>}
			</div>
		</Timeline.Item>
	);
};
